import { createLoadingSpinner, LoadingSpinner } from '@vfde-brix/ws10/loading-spinner';
import { HtmlId } from '../enum';
import { createComponentById } from '@vfde-brix/ws10/core';

export const mountLoadingSpinner = (id: HtmlId) =>
    createComponentById(createLoadingSpinner, id, {
        optNested: true,
        optSize: 'medium',
        business: {},
    });

export const updateLoadingSpinner = (comp: LoadingSpinner | null, show: boolean) => {
    if (!comp) {
        return;
    }

    comp.toggleContainer(!show);
    comp.toggle(show);
};
